import BaseComponent from 'foundation/base-component';
import React from 'react';
import { render } from 'react-dom';
import ScrollToTopButton from './scroll-to-top-button';


class ScrollToTopComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        render(
            <ScrollToTopButton />,
            this.element
        );
    }
}

export default ScrollToTopComponent;
